import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { StateContext } from '../util/providers/StateProvider';
import { SelectButton, SelectButtonChangeEvent } from 'primereact/selectbutton';
import { languages } from '../Settings/data';
import { Button } from 'primereact/button';

interface Props {
  single?: boolean;
}

export const LanguagePicker = (props: Props): ReactNode => {
  const {language, setLanguage} = useContext(StateContext);
  if (props.single) {
    for (const lg of languages) {
      if (lg !== language) {
        return <Button
          rounded={true}
          className={'h-2rem w-2rem p-0'}
          label={lg.toUpperCase()}
          text={true}
          onClick={() => setLanguage(lg)}/>;
      }
    }
  }
  return (
    <SelectButton
      className={'small'}
      options={languages}
      value={language}
      onChange={(e: SelectButtonChangeEvent): void => setLanguage(e.target.value)}
      allowEmpty={false}
    ></SelectButton>
  );
};
